function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { SearchBox } from "@selfpub/selfpub-ui";
import Link from "ui-components/Link";
import { qs } from "scripts/data_utils/domHelpers";
import { apiAnalytics, apiFaqSearch } from "scripts/constants/api";
import doFetch from "scripts/data_utils/doFetch";
import { ArticleText, ButtonWrapper, Container, EmptySearch, FaqArticle, FaqHeader, ItemTitleWrapper, MoreButton, PseudoLinkIcon, SearchItem, SearchList, SearchOutput } from "./styles";
const transitionsProps = {
  transitionName: "fade",
  transitionEnterTimeout: 300,
  transitionLeaveTimeout: 300,
  transitionAppear: true,
  transitionAppearTimeout: 300
};

const textClean = (text = "") => text.replace(/&nbsp;/gi, " ");

class FaqSearch extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      count: 1,
      search: "",
      matched: [],
      prevMatched: [],
      loading: false,
      initialView: true,
      defaultFaq: "",
      nextPageLink: false,
      canGetMore: false
    });

    _defineProperty(this, "sendAnalytics", (link = "") => {
      doFetch(apiAnalytics, {
        body: JSON.stringify({
          data: {
            user_id: window.app.user.id || null,
            link,
            term: this.state.search
          },
          type: "faq_article"
        }),
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST"
      });
    });

    _defineProperty(this, "removeOldRoot", () => {
      this.oldRoot.parentNode && this.oldRoot.parentNode.removeChild(this.oldRoot);
      this.setState({
        loading: false
      });
    });

    _defineProperty(this, "memoizeOldData", () => {
      this.oldRoot = this.oldRoot || qs("#old-root");
      this.defaultFaq = this.oldRoot.outerHTML;
    });

    _defineProperty(this, "handleChange", (response, search) => {
      if (!search.length) {
        this.setState({
          initialView: true,
          matched: []
        });
        return;
      }

      this.setState({
        initialView: false
      }, this.removeOldRoot);
      const {
        result: {
          results: matched = [],
          next: nextPageLink,
          count
        } = {}
      } = response;
      const canGetMore = this.checkCanGetMore(nextPageLink, count, matched);
      this.setState({
        count,
        search,
        matched,
        prevMatched: matched,
        canGetMore,
        nextPageLink,
        loading: false
      });
    });

    _defineProperty(this, "copyArticleLink", url => {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.value = `${window.location.origin}${url}`;
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
    });

    _defineProperty(this, "getSearchList", items => items.map(({
      name,
      url,
      preview
    }, index) => /*#__PURE__*/React.createElement(SearchItem, {
      key: index
    }, /*#__PURE__*/React.createElement(ItemTitleWrapper, null, /*#__PURE__*/React.createElement(FaqArticle, {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: () => this.sendAnalytics(url)
    }, textClean(name)), /*#__PURE__*/React.createElement(PseudoLinkIcon, {
      onClick: () => this.copyArticleLink(url)
    })), /*#__PURE__*/React.createElement(Link, {
      href: url,
      target: "_blank",
      onClick: () => this.sendAnalytics(url)
    }, /*#__PURE__*/React.createElement(ArticleText, null, textClean(preview))))));

    _defineProperty(this, "checkCanGetMore", (nextPageLink, count, data) => !!nextPageLink && count > data.length);

    _defineProperty(this, "_onChangeMoreResults", () => {
      const {
        nextPageLink
      } = this.state;
      doFetch(nextPageLink).then(response => {
        const {
          result: {
            results: data,
            next: nextPageLink,
            count
          }
        } = response;
        const canGetMore = this.checkCanGetMore(nextPageLink, count, data);
        this.setState(state => ({
          matched: [...state.matched, ...data],
          prevMatched: state.matched,
          nextPageLink,
          canGetMore,
          count
        }));
      });
    });
  }

  componentWillMount() {
    // Remember static data renderer with backend
    this.memoizeOldData(); // Remove old data

    this.removeOldRoot();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this.state.matched !== nextState.matched;
  }

  render() {
    const {
      canGetMore,
      count,
      matched,
      loading,
      initialView
    } = this.state;
    const matchedItems = this.getSearchList(matched);
    const searchProps = {
      loading,
      dataUpdater: `${apiFaqSearch}?term=%s`,
      onUpdate: this.handleChange,
      placeholder: "Искать ответ по теме..."
    };
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FaqHeader, {
      id: "faq-header",
      level: 2
    }, "\u0421\u0430\u043C\u044B\u0435 \u043F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043E \u0441\u0435\u0440\u0432\u0438\u0441\u0435"), /*#__PURE__*/React.createElement(SearchBox, searchProps), initialView ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.defaultFaq
      }
    }) : /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, transitionsProps, count ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchOutput, null, /*#__PURE__*/React.createElement(SearchList, null, matchedItems)), canGetMore && /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(MoreButton, {
      stretched: false,
      onClick: this._onChangeMoreResults
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0435\u0449\u0435"))) : /*#__PURE__*/React.createElement(EmptySearch, null, "\u041C\u044B \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0448\u043B\u0438, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0443\u0442\u043E\u0447\u043D\u0438\u0442\u044C \u0437\u0430\u043F\u0440\u043E\u0441.")));
  }

}

export default FaqSearch;